import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const DISTANCE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isDefaultDistance', 'Entity.Distance.IsDefaultDistance')
    .build(),
  FieldBuilder
    .number('distanceValue', 'Entity.Distance.DistanceValue')
    .required()
    .decimal(2,10)
    .build(),
];

export const DISTANCE_CONFIG = {
  entityName: 'Distance',
  localizationKey: 'General::Entity.Distance',
  fields: DISTANCE_FIELDS,
  permission: 'ControllingLiquidations.Distances',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
